import React from "react";
import { AppNotificationLevels } from "../../declarations/message";
import ErrorIcon from "./error";
import InfoIcon from "./info";
import SuccessIcon from "./success";
import WarningIcon from "./warning";

const NotificationIcon = ({level}:{level:AppNotificationLevels})=>{
    switch(level){
        case 'info':
            return <InfoIcon />
        case 'success':
            return <SuccessIcon />
        case 'warning':
            return <WarningIcon />
        case 'error':
            return <ErrorIcon />
        default:
            throw Error('wrong notification level '+level);
    }
}

export default NotificationIcon;